import request from "@/utils/request";
import { EventSourcePolyfill } from "event-source-polyfill";
import { getToken } from "@/utils/auth";
// var baseURL = "http://172.18.20.49:8080";
// if (process.env.VUE_APP_BASE_API != "/") {
//   // debugger;
//   console.log("process.env.VUE_APP_BASE_API:", process.env.VUE_APP_BASE_API);
//   baseURL = process.env.VUE_APP_BASE_API;
// }
var baseURL = window.location.origin;
// var baseURL = "http://172.18.20.49:8080";
if (process.env.VUE_APP_BASE_API != "/") {
  // debugger;
  console.log("process.env.VUE_APP_BASE_API:", process.env.VUE_APP_BASE_API);
  baseURL = process.env.VUE_APP_BASE_API;
}


export function FileUpload(data) {
  console.log(data);
  return request({
    url: "/bosc/api/file/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data;",
    },
  });
}
export function dutUpload(data) {
  console.log(data);
  return request({
    url: "/bosc/api/uvmCanvas/uploadZip",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data;",
    },
  });
}
export function TBRUN(data) {
  return request({
    url: "/bosc/api/uvmCanvas/generationCanvas",
    method: "post",
    data,
  });
}
export function SAVECANVAS(data) {
  return request({
    url: "/bosc/api/uvmCanvas/saveOrupdateCanvas",
    method: "post",
    data,
  });
}
export function getProjectList() {
  return request({
    url: "/bosc/api/uvmCanvas/getCanvasByCreateBy",
    method: "get",
  });
}
export function getProjetContent(name) {
  return request({
    url: "/bosc/api/uvmCanvas/selectCanvasByUvmName/" + name,
    method: "get",
  });
}
export function getFileList() {
  return request({
    url:
      "/bosc/api/file/findFilePath/" +
      (window.saveProjectName ? window.saveProjectName : ""),
    method: "get",
  });
}
export function getFileDetail(path) {
  return request({
    url: "/bosc/api/uvmCanvas/readFile?filePath=" + path,
    method: "get",
  });
}
export function writeFile(data) {
  return request({
    url: "/bosc/api/uvmCanvas/writeFile",
    method: "post",
    data,
  });
}
export function compileUvmCanvas(data) {
  return request({
    url: "/bosc/api/uvmCanvas/compileUvmCanvas",
    method: "post",
    data,
  });
}

// get Create Verilator
export function compileUvmCanvasStream(data) {
  var paramStr = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (paramStr != "") {
      paramStr = paramStr + "&" + key + "=" + value;
    } else {
      paramStr = paramStr + key + "=" + value;
    }
  });
  // const paramStr = new URLSearchParams(data).toString();
  const eventSource = new EventSourcePolyfill(
    `${baseURL}/bosc/api/uvmCanvas/compileUvmCanvas?${paramStr}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
        token: getToken(),
        "Content-Type": "text/event-stream;charset=UTF-8;",
        "Cache-Control": "no-cache",
        Connection: "keep-alive",
        Accept: "text/event-stream",
      },
      heartbeatTimeout: 300000,
      withCredentials: true,
    }
  );
  return eventSource;
}

// /bosc/api/uvmCanvas/waveUvmCanvas
export function waveUvmCanvas(data) {
  return request({
    url: "/bosc/api/uvmCanvas/waveUvmCanvas",
    method: "post",
    data,
  });
}
export function createCodeServer() {
  return request({
    url: "/bosc/api/docker/createCodeServer",
    method: "get",
  });
}

export function pauseCodeServer() {
  return request({
    url: "/bosc/api/docker/pauseCodeServer",
    method: "get",
  });
}

export function createCodeSimDebug() {
  return request({
    url: "/bosc/api/simDebug/createCodeSimDebug",
    method: "get",
  });
}

export function deleteCodeSimDebug() {
  return request({
    url: "/bosc/api/docker/deleteCodeSimDebug",
    method: "get",
  });
}

export function pauseCodeSimDebug() {
  return request({
    url: "/bosc/api/docker/pauseCodeSimDebug",
    method: "get",
  });
}

export function bspGeneratorRequest(data) {
  return request({
      url: '/bosc/api/bsp/generator',
      method: 'post',
      data
  })
}

export function readConfigFile(query) {
  return request({
      url: '/bosc/api/file/readFile',
      method: 'get',
      params: query
  })
}

export function writeSourceFile(data) {
  return request({
      url: '/bosc/api/file/writeFile',
      method: 'post',
      data
  })
}

export function downloadFile(params) {
  return request({
    url: "/bosc/api/regression/downloadFile",
    method: "get",
    params,
  });
}
export function findFilePath(data) {
  return request({
    url: "/bosc/api/resourceManager/findFilePath",
    method: "post",
    data,
  });
}
export function getFileName(data) {
  return request({
    url: "/bosc/api/resourceManager/getFileName",
    method: "post",
    data,
  });
}
export function dockerStatus() {
  return request({
    url: "/bosc/api/docker/codeStatus",
    method: "post",
  });
}

export function exportMiddleware(data) {
  return request({
    url: "/bosc/api/middleware/generator",
    method: "post",
    data,
  });
}

export function exportOsPorting(data) {
  return request({
    url: "/bosc/api/osporting/generator",
    method: "post",
    data,
  });
}

export function getVersion() {
  return request({
    url: "/bosc/api/resourceManager/version",
    method: "get",
  });
}

export function  getTemplate(data) {
  return request({
    url: "/bosc/api/template/getTemplate",
    method: "post",
    data
  })
}
 
export function upload(data) {
  return request({
    url: "/bosc/api/resourceManager/uploadCodeServerFile",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function deleteFile(data) {
  return request({
    url: "/bosc/api/resourceManager/deleteFile",
    method: "post",
    data,
  });
}

export function generator(data) {
  return request({
    url: "/bosc/api/resourceManager/createCodeServerFile",
    method: "post",
    data,
  });
}
export function getAlUvmCanvas(num) {
  return request({
    url: `/bosc/api/HomePage/getAllUvmCanvas/${num}`,
    method: "get",
  });
}

export function getEditPort () {
  return request({
    url: `/bosc/api/editServer/createEditServer`,
    method: "get",
  });
}

export function getCreateAi() {
  return request({
    url: "/bosc/api/codeFuseIdeController/createAiEdit",
    method: "get",
  });
}

export function bspGenerator(data) {
    return request({
        url: '/bosc/api/bsp/loadCodeGeneration',
        method: 'post',
        data
    })
}

export function writeFileApi(data) {
  return request({
      url: '/bosc/api/file/writeFile',
      method: 'post',
      data
  })
}